import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=6e158656"
import script from "./Badge.vue?vue&type=script&setup=true&lang=js"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports